import { render, staticRenderFns } from "./score.vue?vue&type=template&id=78ed5ba0&scoped=true&"
import script from "./score.vue?vue&type=script&lang=ts&"
export * from "./score.vue?vue&type=script&lang=ts&"
import style0 from "./score.vue?vue&type=style&index=0&id=78ed5ba0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ed5ba0",
  null
  
)

export default component.exports